import React, { useState, useCallback, useEffect } from "react";
import "./CustomSwitch.scss";

type CustomSwitchProps = {
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	name: string;
	onSwitchIcon: string;
	offSwitchIcon: string;
	checked?: boolean;
};

function CustomSwitch({
	onChange,
	name,
	onSwitchIcon,
	offSwitchIcon,
	checked,
}: CustomSwitchProps) {
	const [isOn, setIsOn] = useState(checked !== undefined ? checked : false);

	useEffect(() => {
		if (checked !== undefined) {
			setIsOn(checked);
		}
	}, [checked]);

	const toggleSwitch = useCallback(() => {
		const newIsOn = !isOn;
		setIsOn(newIsOn);
		onChange({
			target: {
				name,
				value: newIsOn.toString(),
				type: "checkbox",
				checked: newIsOn,
			} as HTMLInputElement,
			currentTarget: {
				name,
				value: newIsOn.toString(),
				type: "checkbox",
				checked: newIsOn,
			} as HTMLInputElement,
		} as React.ChangeEvent<HTMLInputElement>);
	}, [isOn, onChange, name]);

	return (
		<div className="switch-container" onClick={toggleSwitch}>
			<div className={`switch-track ${isOn ? "on" : "off"}`}>
				<div className={`switch-thumb ${isOn ? "on" : "off"}`}>
					<img
						src={onSwitchIcon}
						alt="Switch On"
						className="thumb-icon on-icon"
						draggable="false"
					/>
					<img
						src={offSwitchIcon}
						alt="Switch Off"
						className="thumb-icon off-icon"
						draggable="false"
					/>
				</div>
			</div>
		</div>
	);
}

export default CustomSwitch;
